// Starting a download of a signed export link (UC-GOVERNANCE-004, -006, -012). The link is followed from the page itself: a
// window opened after the export call has answered is not a direct response to the click any more, and Safari — the iPad at
// the desk — blocks it without a word, so the file never came (review of 2 Oct 2026, S6). The file is served as an
// attachment, so following its link downloads it and never leaves the app.
export function startDownload(url: string, fileName: string): void {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.rel = "noopener";
  a.hidden = true;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
